import { createContext, SetStateAction } from "react";
import type { FormFields } from "../../components/page/page.schema";
import { AvailableProducts, BackgroundTheme, PageTheme, DefaultUserThemes, GroupTheme, HeaderTheme, NavbarTheme, ReferralTheme } from "referral-types";
import { KeyedMutator } from "swr";

export type StoreThemeContextType = {
  defaultThemes?: DefaultUserThemes;

  selectedCategory: string;
  setSelectedCategory: (category: string) => void;

  selectedBackgroundTheme?: BackgroundTheme;
  setSelectedBackgroundTheme: (theme: BackgroundTheme) => void;
  selectedPageTheme?: PageTheme;
  setSelectedPageTheme: (theme: PageTheme) => void;
  selectedGroupTheme?: GroupTheme;
  setSelectedGroupTheme: (theme: GroupTheme) => void;
  selectedReferralTheme?: ReferralTheme;
  setSelectedReferralTheme: (theme: ReferralTheme) => void;
  selectedNavbarTheme?: NavbarTheme;
  setSelectedNavbarTheme: (theme: NavbarTheme) => void;
  selectedHeaderTheme?: HeaderTheme;
  setSelectedHeaderTheme: (theme: HeaderTheme) => void;

  incrementFeaturedTheme: () => void;

  availableProducts?: AvailableProducts;

  storeRevision?: FormFields;
  setStoreRevision: (fields: SetStateAction<FormFields | undefined>) => void;

  logoOverride?: File | null;
  setLogoOverride: (file?: File | null) => void;
  backgroundImageOverride?: File | null;
  setBackgroundImageOverride: (file?: File | null) => void;
  backgroundImageMobileOverride?: File | null;
  setBackgroundImageMobileOverride: (file?: File | null) => void;
  groupMediaOverride?: File | null;
  setGroupMediaOverride: (file?: File | null) => void;
  headerMediaOverride?: File | null;
  setHeaderMediaOverride: (file?: File | null) => void;

  mutator: KeyedMutator<AvailableProducts>;
};

export const StoreContext = createContext<StoreThemeContextType | undefined>(undefined);
